import { Link } from 'react-router-dom';
import './Footer.css'
let Footer=()=>{
    return(
        <div className='footermaindiv'>
            <div className='footerfirstrow footerrows'>
                    <h2>LINK SECTION</h2>
                    <Link className='a'>---------</Link>
                    <Link className='a'>---------</Link>
                    <Link className='a'>---------</Link>
                    <Link className='a'>---------</Link>
                    <Link className='a'>---------</Link>
            </div>
            <div className='footersecondrow footerrows'>  
                <h2>Devt. Inprogress</h2>
            </div>
            <div className='footerthirdrow footerrows'>
                <h2>Devt. Inprogress</h2>
            </div>  
        </div>
    );
    

}
export default Footer;